import { CustomerConfig } from './types'

const config: CustomerConfig = {
  entraClientId: '7c4dee4e-64cd-4756-9d11-c1d8e118e97c',
  header: 'Helsebiblioteket - pasientinformasjon',
  headerLogoUrl: {
    light: '/logos/HB_logo.svg',
    dark: '/logos/HB_logo_dark.svg',
  },
  subheader: '',
  version: 'Alfa 1.0',
  logo: 'semantic_lab_logo_hvit.png',
  theme: {
    isLight: true,
    bgColor: 'bg-gray-800',
    textColor: 'text-fancy-wood',
    bubbles: 'gray-800',
  },
  chatServer:
    (process.env.REACT_APP_CHAT_SERVER || 'https://ai.semanticlab.no') +
    '/api/v1/chatbots/pasient',
}
export default config
